import React, { useEffect, useState } from "react";
import { useLang } from "@/contexts/LanguageContext";

export const CookieBanner = () => {
  const { t } = useLang();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const stored = localStorage.getItem("orion-cookie");
    if (!stored) setVisible(true);
  }, []);

  const handle = (decision) => {
    localStorage.setItem("orion-cookie", decision);
    setVisible(false);
  };

  if (!visible) return null;
  return (
    <div
      data-testid="cookie-banner"
      className="fixed bottom-4 left-1/2 -translate-x-1/2 z-40 w-[min(960px,calc(100vw-32px))]"
    >
      <div className="rounded-2xl border border-slate-200 bg-white/85 backdrop-blur-xl shadow-2xl p-5 sm:p-6 flex flex-col sm:flex-row sm:items-center gap-4">
        <p className="text-sm text-slate-700 leading-relaxed flex-1">{t("cookie.message")}</p>
        <div className="flex gap-3 shrink-0">
          <button
            data-testid="cookie-decline"
            onClick={() => handle("declined")}
            className="px-5 py-2.5 rounded-full border border-slate-300 text-sm font-semibold text-slate-700 hover:bg-slate-100 transition-colors"
          >
            {t("cookie.decline")}
          </button>
          <button
            data-testid="cookie-accept"
            onClick={() => handle("accepted")}
            className="px-5 py-2.5 rounded-full bg-blue-600 text-white text-sm font-semibold hover:bg-blue-700 transition-colors"
          >
            {t("cookie.accept")}
          </button>
        </div>
      </div>
    </div>
  );
};
